import type {Selection} from '@react-types/shared';

export function areSelectionsEqual(set1: Selection, set2: Selection) {
  if (set1.size !== set2.size) {
    return false;
  }

  return Array.from(set1).every((elem) => set2.has(elem));
}
